import accountsJwtService from 'app/services/jwtService';
import { isNil } from 'lodash';

import { HTTP_RESPONSE_STATUS_CODES } from 'constants/http';
import { logger } from 'utils/logger';
import { getIsNativePlatform } from 'utils/platform';

import { LOGIN_ERROR_MESSAGES } from './JWTLoginTab.constants';

const LOGIN_ERROR_STATUS_MESSAGES = {
  [HTTP_RESPONSE_STATUS_CODES.BAD_REQUEST]: LOGIN_ERROR_MESSAGES.invalidCredentials,
  [HTTP_RESPONSE_STATUS_CODES.UNAUTHORIZED]: LOGIN_ERROR_MESSAGES.invalidCredentials,
  [HTTP_RESPONSE_STATUS_CODES.FORBIDDEN]: LOGIN_ERROR_MESSAGES.noAccess,
  [HTTP_RESPONSE_STATUS_CODES.TOO_MANY_REQUESTS]: LOGIN_ERROR_MESSAGES.tooManyAttempts,
};

// Maps a sign-in failure (the Axios error stored in auth.login.error) to human-facing copy,
// keyed on HTTP status so we never surface the raw backend string. Returns null when there is
// no error to show.
export const getLoginErrorMessage = error => {
  if (isNil(error)) {
    return null;
  }

  const status = error?.response?.status;

  if (isNil(status)) {
    // No HTTP response reached the client — Axios sets `request` (but no `response`) on a
    // network/connectivity failure, which is distinct from a server-rejected sign-in.
    return error?.request ? LOGIN_ERROR_MESSAGES.network : LOGIN_ERROR_MESSAGES.generic;
  }

  if (status >= HTTP_RESPONSE_STATUS_CODES.INTERNAL_SERVER_ERROR) {
    return LOGIN_ERROR_MESSAGES.serverError;
  }

  return LOGIN_ERROR_STATUS_MESSAGES[status] ?? LOGIN_ERROR_MESSAGES.generic;
};

export const upgradeToTrustedDevice = async () => {
  if (!getIsNativePlatform()) {
    return;
  }

  try {
    await accountsJwtService.trustDevice();
  } catch (error) {
    logger.error('[JWTLoginTab] trust-device upgrade failed', error);
  }
};
